/* Small, section-editor-safe enhancements. Content remains available without JavaScript. */
if (!customElements.get('teema-tabs')) {
  customElements.define('teema-tabs', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.querySelector('[data-tab-list]')?.setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', tab.dataset.tab);
        tab.addEventListener('click', () => this.select(index), options);
        tab.addEventListener('keydown', (event) => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        }, options);
      });
      this.panels.forEach(panel => { panel.setAttribute('role', 'tabpanel'); panel.tabIndex = 0; });
      this.select(0);
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel === event.target || panel.contains(event.target));
        if (index >= 0) this.select(index);
      }, options);
    }
    select(index) {
      this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
if (!customElements.get('teema-rail')) {
  customElements.define('teema-rail', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.rail = this.querySelector('.teema-rail');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      if (!this.rail) return;
      this.setAttribute('data-enhanced', '');
      const move = direction => this.rail.scrollBy({ left: direction * this.rail.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      this.previous.addEventListener('click', () => move(-1), options);
      this.next.addEventListener('click', () => move(1), options);
      this.rail.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.rail);
      this.update();
      this.addEventListener('play', event => this.querySelectorAll('video').forEach(video => { if (video !== event.target) video.pause(); }), { ...options, capture: true });
    }
    update() {
      this.previous.disabled = this.rail.scrollLeft <= 2;
      this.next.disabled = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 2;
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  });
}
